import React, { useState, useEffect, useContext } from "react"
import { Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useLocation } from "react-router-dom"
import toast from "react-hot-toast"
import Navbar from "../../../Components/Navbar/Navbar"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import DatePicker from "react-datepicker"
import {
  getTodayDate,
  refreshPage,
  toastStyle,
  TokenExpiry,
  getType,
  numberFormat,
  selectDropdownStyle,
  getSevenDaysAgo,
  formatDateNoTime,
  startOfMonth,
  endOfMonth,
} from "../../../Helpers/Utils/Common"
import * as XLSX from "xlsx"
import Moment from "moment"
import Select from "react-select"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import {
  deleteSalesInvoice,
  getSalesInvoice,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceApi"
import { getSalesOrder } from "../../../Helpers/apiCalls/SalesModule/SalesOrderApi"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import GenerateBirModal from "../../Purchases/PurchaseOrders/Components/GenerateBirModal"
import BirForm from "../../Purchases/Pay Suppliers/Components/BirForm"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function WholesaleInvoice() {
  let navigate = useNavigate()
  const userType = getType()
  const [inactive, setInactive] = useState(true)
  const [showLoader, setShowLoader] = useState(false)
  const [customers, setCustomers] = useState([])
  const [isClicked, setIsClicked] = useState(false)
  const [excelData, setExcelData] = useState([])
  const [tableData, setTableData] = useState([])
  const [salesOrders, setSalesOrders] = useState([])
  const [selectedRow, setSelectedRow] = useState({})
  const [showAddModal, setShowAddModal] = useState(false)
  const [selectedSalesOrderId, setSelectedSalesOrderId] = useState()
  const [summary, setSummary] = useState({})
  const location = useLocation()
  const dateToday = getTodayDate()
  const options = [
    {
      id: 0,
      label: "All Invoices",
      value: "all",
    },
    {
      id: 1,
      label: "With Invoice",
      value: "yes",
    },
    {
      id: 2,
      label: "No Invoice",
      value: "no",
    },
  ]

  const [showGenerateBirModal, setShowGenerateBirModal] = useState(false)
  const handleShowGenerateBirModal = () => setShowGenerateBirModal(true)
  const handleCloseGenerateBirModal = () => setShowGenerateBirModal(false)

  const xlsxHeaders = [
    "SALES DATE",
    "INV NO.",
    "CUSTOMER",
    "BRANCH",
    "TOTAL",
    "PAID AMNT",
    "BALANCE",
    "STATUS",
    "SO NO.",
  ]

  const thirtyDaysBefore = (givenDate) => {
    const newDate = new Date(givenDate)
    newDate.setDate(newDate.getDate() - 30)
    newDate.setTime(newDate.getTime() - 1)
    return newDate
  }
  const getMonthFromUrl = () => {
    const searchParams = new URLSearchParams(location.search)
    return searchParams.get("month")
  }
  const defaultStartDate = thirtyDaysBefore(dateToday)
  const month = getMonthFromUrl()
  const startDate = month ? startOfMonth(month) : defaultStartDate
  const endDate = month ? endOfMonth(month) : new Date()

  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)
  /* FILTER CONFIGS */
  const [filterConfig, setFilterConfig] = useState({
    date_from: dateFilter.date_from ? dateFilter.date_from : startDate,
    date_to: dateFilter.date_to ? dateFilter.date_to : endDate,
    franchise: "",
    tab: currentTab ? currentTab : "all",
    status: "",
    payment_status: "",
    franchised_on_from: "",
    franchised_on_to: "",
    page: 1,
    customer_id_value: {
      label: "All Customers",
      value: "",
    },
    with_invoice: "all",
    inv_name: "All Invoices",
  })

  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        status: tabKey,
        branch_id: "",
        customer_id: "",
        customer_id_value: {
          label: "All Customers",
          value: "",
        },
        date_from: dateFilter.date_from
          ? dateFilter.date_from
          : getSevenDaysAgo(),
        date_to: dateFilter.date_to ? dateFilter.date_to : getTodayDate(),
        page: 1,
        with_invoice: "all",
        inv_name: "All Invoices",
      }
    })
  }

  async function fetchData() {
    setShowLoader(true)
    setTableData([])
    setExcelData([])
    setTotalItems(0)

    const response = await getSalesInvoice(filterConfig)
    if (response.data) {
      const summaryEntries = Object.entries(response.data.summary)
      const summaryObject = Object.fromEntries(summaryEntries)
      setSummary(summaryObject)

      var sortedData = response.data.data.sort((a, b) =>
        a.branch_name > b.branch_name
          ? 1
          : b.branch_name > a.branch_name
          ? -1
          : 0
      )

      var allBills = sortedData.map((data) => {
        var info = data
        info.sales_date =
          data.sales_date !== "0000-00-00"
            ? Moment(data.sales_date).format("MMM DD, YYYY")
            : "None"
        info.delivery_date =
          data.delivery_date !== "0000-00-00"
            ? Moment(data.delivery_date).format("MMM DD, YYYY")
            : "None"
        info.doc_no = data.id
        info.grand_total = numberFormat(info.grand_total)
        info.paid_amount = numberFormat(info.paid_amount)
        return info
      })
      setTableData(allBills)

      var excel = allBills.map((bill) => {
        var info = {}
        info.sales_date = bill.sales_date
        info.id = bill.id
        info.customer_name = bill.customer_name
        info.branch_name = bill.branch_name
        // info.release_from_name = bill.release_from_name
        info.grand_total = bill.grand_total
        info.paid_amount = bill.paid_amount
        info.balance = bill.balance
        info.status = bill.status
        info.sales_order_id = bill.sales_order_id
        return info
      })
      setExcelData(excel)
      setTotalItems(response.data.size)
    } else if (response.error) {
      setSummary(0)
      TokenExpiry(response)
    }
    setShowLoader(false)
  }

  function handleExport() {
    const rows = excelData
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
    XLSX.writeFile(workbook, "SalesInvoice.xlsx", { compression: true })
  }

  async function fetchCustomers() {
    setShowLoader(true)

    const response = await getCustomer({})

    if (response.error) {
      TokenExpiry(response.error)
    } else {
      var data = response.data.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.var_name = "customer_id"
        return info
      })
      setCustomers([{ label: "All Customers", value: "" }, ...data])
    }
    setShowLoader(false)
  }

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  async function handleDeletePI() {
    setIsClicked(true)
    const response = await deleteSalesInvoice(selectedRow.id)

    if (response.data) {
      toast.success("Sales Invoice Deleted Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Error Deleting Sales Invoice", {
        style: toastStyle(),
      })
    }
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit") {
      navigate("edit/" + row.id)
    } else if (e.target.value === "print") {
      navigate("print/" + row.id)
    } else if (e.target.value === "delete") {
      handleShowDeleteModal()
    } else if (e.target.value === "bir") {
      handleShowGenerateBirModal()
    }
  }

  async function handleGenerateBir2037() {
    if (selectedRow.withholding_tax !== "0.00") {
      setIsClicked(true)
      toast.loading("Printing BIR 2307", { style: toastStyle() })
      setTimeout(() => {
        toast.dismiss()
        Print()
      }, 1000)
    } else {
      toast.error(
        "We cannot generate a BIR 2307 for this record because the withholding tax amount is 0.",
        { style: toastStyle() }
      )
    }
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="print" className="color-options">
          Print
        </option>
        {row.withholding_tax !== "0.00" ? (
          <option value="bir" className="color-options">
            Generate BIR 2307
          </option>
        ) : null}
        {(userType === "admin" || userType === "wholesale_head") && (
          <option value="delete" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  function ViewBtn(row) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={(e) => handleViewBtn(row.id)}
      >
        View
      </button>
    )
  }

  function ContractBtn(row) {
    return (
      <div className="d-flex flex-column gap-1">
        {row.sales_invoice_payments.map((item, index) => (
          <button
            key={index}
            type="button"
            className="invoice-button"
            onClick={() => handleViewReturn(item.id, item.payment_mode)}
          >
            {item.id}
          </button>
        ))}
      </div>
    )
  }

  function handleViewReturn(id, type) {
    const nav_url = `salespayment/view/${id}/${type}`
    window.open(nav_url, "_blank")
  }

  function handleViewBtn(id) {
    navigate("/wholesaleinvoice/print/" + id)
  }

  function handleContinueClick() {
    if (selectedSalesOrderId === undefined) {
      toast.error("Please select a sales order to proceed", {
        style: toastStyle(),
      })
    } else {
      navigate(`/wholesaleinvoice/add/${selectedSalesOrderId}`)
    }
  }

  useEffect(() => {
    fetchCustomers()
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  useEffect(() => {
    async function fetchSalesOrders() {
      setSalesOrders([])
      const response = await getSalesOrder({ status: "pending" })
      if (response.data) {
        const res = response.data.data.map((row) => {
          var info = {}
          info.label = `Sales Order No. ${row.id} (${row.customer_name})`
          info.value = row.id
          return info
        })
        setSalesOrders(res)
      }
    }

    fetchSalesOrders()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SALES INVOICE{" "}
            </h1>
          </Col>
          <Col xs={12} lg={3} className="mt-2 mt-lg-0">
            <input
              type="search"
              name="anything"
              placeholder="Search anything..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
              className="search-bar"
            />
          </Col>
          <Col lg={2} className="mt-2 mt-lg-0">
            <div className="PO-filters">
              <button
                className="add-btn"
                onClick={() => setShowAddModal(true)}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>

        {/* newtabs */}
        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          className="mt-3 mt-md-5 PO-tabs"
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="open" title="Open Bills" className="pt-2">
            {/* table */}
            {/* filters */}
            <Row>
              <Col>
                <div className="my-2 px-4 PO-filters d-flex flex-row mb-2 filter flex-column">
                  {/* <span className="me-4 align-middle d-none d-md-inline mt-2">
                    Filter By:
                  </span>
                  <Row className="d-flex flex-row">
                    <Col md={2} className="col-lg-3 col-md-6 col-sm-6">
                      <Select
                        className="dropsearch-filter px-0 py-0 me-2"
                        classNamePrefix="react-select"
                        placeholder="Select Customer"
                        styles={selectDropdownStyle}
                        value={filterConfig.customer_id_value}
                        options={customers}
                        onChange={(e) => {
                          setFilterConfig((prev) => {
                            return {
                              ...prev,
                              customer_id: e.value,
                              [e.var_name]: e.value,
                              customer_id_value: {
                                label: e.label,
                                value: e.value,
                              },
                            }
                          })
                        }}
                      />
                    </Col>
                  </Row> */}
                  <p className="d-none d-md-flex mb-0 w-full">FILTER BY:</p>
                  <Row className="PO-filters mb-2">
                    <Col md={6} lg={3} className="">
                      <Select
                        className="dropsearch-filter w-full"
                        classNamePrefix="react-select"
                        placeholder="Select Customer"
                        styles={selectDropdownStyle}
                        value={filterConfig.customer_id_value}
                        options={customers}
                        onChange={(e) => {
                          setFilterConfig((prev) => {
                            return {
                              ...prev,
                              customer_id: e.value,
                              [e.var_name]: e.value,
                              customer_id_value: {
                                label: e.label,
                                value: e.value,
                              },
                            }
                          })
                        }}
                      />
                    </Col>
                    <Col md={6} lg={3} className="my-1">
                      <Select
                        className="dropsearch-filter px-0 py-0 me-3"
                        classNamePrefix="react-select"
                        // placeholder="All Invoices"
                        styles={selectDropdownStyle}
                        placeholder={filterConfig.inv_name}
                        value={filterConfig.with_invoice}
                        options={options}
                        onChange={(e) => {
                          setFilterConfig((prev) => {
                            return {
                              ...prev,
                              with_invoice: e.value,
                              inv_name: e.label,
                              [e.var_name]: e.id,
                              invoice_id_value: {
                                label: e.label,
                                value: e.id,
                              },
                            }
                          })
                        }}
                      />
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="justify-content-between justify-content-sm-start"
                    >
                      <DatePicker
                        autoComplete="off"
                        name="date_from"
                        placeholderText={formatDateNoTime(getSevenDaysAgo())}
                        selected={filterConfig.date_from}
                        onChange={(date) => {
                          setDateFrom(moment(date).format("YYYY-MM-DD"))
                          setFilterConfig((prev) => {
                            return { ...prev, date_from: date }
                          })
                        }}
                        // maxDate={dateToday}
                        fixedHeight
                        className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                        showYearDropdown
                        dateFormatCalendar="MMMM"
                        dateFormat="MMMM dd, yyyy"
                        yearDropdownItemNumber={20}
                        scrollableYearDropdown
                      />
                    </Col>
                    <Col lg={3} md={6}>
                      <DatePicker
                        autoComplete="off"
                        name="date_to"
                        placeholderText={formatDateNoTime(getTodayDate())}
                        selected={filterConfig.date_to}
                        onChange={(date) => {
                          setDateTo(moment(date).format("YYYY-MM-DD"))
                          setFilterConfig((prev) => {
                            return { ...prev, date_to: date }
                          })
                        }}
                        // maxDate={dateToday}
                        fixedHeight
                        className="PI-date-btn py-3 form-control w-full"
                        showYearDropdown
                        dateFormatCalendar="MMMM"
                        dateFormat="MMMM dd, yyyy"
                        yearDropdownItemNumber={20}
                        scrollableYearDropdown
                      />
                    </Col>
                  </Row>
                  <div className=" PO-filters d-flex justify-content-center gap-1 gap-md-4 pb-3">
                    <span className="mt-2 ps-label">
                      Total Subtotal:{" "}
                      <b>
                        {summary === 0
                        ? "0.00"
                        : numberFormat(summary.total_subtotal)}
                      </b>
                    </span>

                    <span className="mt-2 ps-label">
                      Grand Total:{" "}
                      <b>
                        {summary === 0
                        ? "0.00"
                        : numberFormat(summary.grand_total)}
                      </b>
                    </span>

                    <span className="mt-2 ps-label">
                      Total Paid Amount:{" "}
                      <b>
                        {summary === 0
                        ? "0.00"
                        : numberFormat(summary.total_paid)}
                      </b>
                    </span>

                    <span className="mt-2 ps-label">
                      Total Balance:{" "}
                      <b>
                        {summary === 0
                        ? "0.00"
                        : numberFormat(summary.total_balance)}
                      </b>
                    </span>
                  </div>
                  {/* <div className="mb-2" /> */}
                </div>
              </Col>
            </Row>

            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "SALES DATE",
                "INV NO.",
                "CUSTOMER",
                "BRANCH",
                "TOTAL",
                "PAID AMNT",
                "BALANCE",
                "PMT REF NO",
                "STATUS",
                "SO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "sales_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "grand_total",
                "paid_amount",
                "balance",
                "/",
                "status",
                "sales_order_id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              newTabBtn={(row) => ContractBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="closed" title="closed Bills" className="pt-3">
            <p className="d-none d-md-flex mb-0 ms-4 w-full mb-0">FILTER BY:</p>
            <Row className="PO-filters mb-2 mx-2">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.with_invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="PO-filters d-flex justify-content-center gap-1 gap-md-4 px-4 pb-3">
              <span className="mt-2 ps-label">
                Total Subtotal:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
                </b>
              </span>
              <span className="mt-2 ps-label">
                Grand Total:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
                </b>
              </span>

              <span className="mt-2 ps-label">
                Total Paid Amount:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_paid)}
                </b>
              </span>

              <span className="mt-2 ps-label">
                Total Balance:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_balance)}
                </b>
              </span>
            </div>
            {/* <div className="mb-2" /> */}
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "SALES DATE",
                "INV NO.",
                "CUSTOMER",
                "BRANCH",
                "TOTAL",
                "PAID AMNT",
                "BALANCE",
                "PMT REF NO",
                "STATUS",
                "SO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "sales_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "grand_total",
                "paid_amount",
                "balance",
                "/",
                "status",
                "sales_order_id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              newTabBtn={(row) => ContractBtn(row, "closed_bill")}
              showLoader={showLoader}
              withActionData={false}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="due" title="Due Bills" className="pt-3">
            <p className="d-none d-md-flex mb-0 ms-4 w-full mb-0">FILTER BY:</p>
            <Row className="PO-filters mb-2 mx-2">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.with_invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center gap-1 gap-md-4 px-4 pb-3">
              <span className="mt-2 ps-label">
                Total Subtotal:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
                </b>
              </span>
              <span className="mt-2 ps-label">
                Grand Total:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
                </b>
              </span>

              <span className="mt-2 ps-label">
                Total Paid Amount:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_paid)}
                </b>
              </span>

              <span className="mt-2 ps-label">
                Total Balance:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_balance)}
                </b>
              </span>
            </div>
            {/* <div className="mb-2" /> */}
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "SALES DATE",
                "INV NO.",
                "CUSTOMER",
                "BRANCH",
                "TOTAL",
                "PAID AMNT",
                "BALANCE",
                "PMT REF NO",
                "STATUS",
                "SO NO.",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "sales_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "grand_total",
                "paid_amount",
                "balance",
                "/",
                "status",
                "sales_order_id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              newTabBtn={(row) => ContractBtn(row, "open_bill")}
              showLoader={showLoader}
              withActionData={false}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="all" title="All" className="pt-3">
            <p className="d-none d-md-flex mb-0 ms-4 w-full mb-0">FILTER BY:</p>
            <Row className="PO-filters mb-2 mx-2">
              <Col md={6} lg={3} className="">
                <Select
                  className="dropsearch-filter w-full"
                  classNamePrefix="react-select"
                  placeholder="Select Customer"
                  styles={selectDropdownStyle}
                  value={filterConfig.customer_id_value}
                  options={customers}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        customer_id: e.value,
                        [e.var_name]: e.value,
                        customer_id_value: {
                          label: e.label,
                          value: e.value,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col md={6} lg={3} className="my-1">
                <Select
                  className="dropsearch-filter px-0 py-0 me-3"
                  classNamePrefix="react-select"
                  // placeholder="All Invoices"
                  styles={selectDropdownStyle}
                  placeholder={filterConfig.inv_name}
                  value={filterConfig.with_invoice}
                  options={options}
                  onChange={(e) => {
                    setFilterConfig((prev) => {
                      return {
                        ...prev,
                        with_invoice: e.value,
                        inv_name: e.label,
                        [e.var_name]: e.id,
                        invoice_id_value: {
                          label: e.label,
                          value: e.id,
                        },
                      }
                    })
                  }}
                />
              </Col>
              <Col
                lg={3}
                md={6}
                className="justify-content-between justify-content-sm-start"
              >
                <DatePicker
                  autoComplete="off"
                  name="date_from"
                  placeholderText={formatDateNoTime(getSevenDaysAgo())}
                  selected={filterConfig.date_from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 mb-1 mb-md-0  form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col lg={3} md={6}>
                <DatePicker
                  autoComplete="off"
                  name="date_to"
                  placeholderText={formatDateNoTime(getTodayDate())}
                  selected={filterConfig.date_to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="PI-date-btn py-3 form-control w-full"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  dateFormat="MMMM dd, yyyy"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className=" PO-filters d-flex justify-content-center gap-1 gap-md-4 px-4 pb-3">
              <span className="mt-2 ps-label">
                Total Subtotal:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_subtotal)}
                </b>
              </span>
              <span className="mt-2 ps-label">
                Grand Total:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.grand_total)}
                </b>
              </span>

              <span className="mt-2 ps-label">
                Total Paid Amount:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_paid)}
                </b>
              </span>

              <span className="mt-2 ps-label">
                Total Balance:{" "}
                <b>
                  {summary === 0 ? "0.00" : numberFormat(summary.total_balance)}
                </b>
              </span>
            </div>
            {/* <div className="mb-2" /> */}
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "SALES DATE",
                "INV NO.",
                "CUSTOMER",
                "BRANCH",
                "TOTAL",
                "PAID AMNT",
                "BALANCE",
                "PMT REF NO",
                "STATUS",
                "SO NO",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "sales_date",
                "invoice_no",
                "customer_name",
                "branch_name",
                "grand_total",
                "paid_amount",
                "balance",
                "/",
                "status",
                "sales_order_id",
              ]}
              tableData={tableData}
              ViewBtn={(row) => ViewBtn(row)}
              ActionBtn={(row) => ActionBtn(row, "open_bill")}
              newTabBtn={(row) => ContractBtn(row, "all")}
              showLoader={showLoader}
              withActionData={false}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
        <div className="mb-3" />
        <br />
        <br />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="sales invoice"
        onDelete={() => handleDeletePI()}
        isClicked={isClicked}
      />
      <Modal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        size="lg"
        centered
      >
        <Modal.Body>
          <span className="PI-modal-header">ADD SALES INVOICE</span>
          <div className="PI-modal-body mt-3">
            <span className="PI-modal-label">Sales Order No.</span>
            <span className="color-red"> *</span>
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select Sales Order..."
              options={salesOrders}
              onChange={(e) => setSelectedSalesOrderId(e.value)}
            />
          </div>
          <div className="d-flex justify-content-end pt-4 pb-3">
            <button
              type="button"
              onClick={() => setShowAddModal(false)}
              className="button-secondary me-3"
            >
              Close
            </button>
            <button
              type="button"
              // onClick={() =>
              //   navigate(`/wholesaleinvoice/add/${selectedSalesOrderId}`)
              // }
              onClick={handleContinueClick}
              className="button-primary"
              // disabled={!selectedSalesOrderId}
            >
              Continue
            </button>
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="d-flex justify-content-end pt-5 pb-3">
                    <button
                        type="button"
                        onClick={() => setShowAddModal(false)}
                        className="button-secondary"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                `/wholesaleinvoice/add/${selectedSalesOrderId}`
                            )
                        }
                        className="button-primary"
                    >
                        Continue
                    </button>
                </Modal.Footer> */}
      </Modal>
      {/* <AddPaymentModal
                id={PIID}
                balance={balance}
                franchiseeID={franchiseeID}
                show={showAddPaymentModal}
                onHide={handleCloseAddPaymentModal}
            />
            <ConfirmPaymentModal
                // id={PIID}
                // balance={balance}
                // franchiseeID={franchiseeID}
                show={showConfirmPaymentModal}
                onHide={handleCloseConfirmPaymentModal}
                handler={handleShowAddPaymentModal}
            /> */}
      <Footer />
      <GenerateBirModal
        show={showGenerateBirModal}
        hide={() => handleCloseGenerateBirModal()}
        message="Are you sure you want to Generate BIR 2037 for this sales invoice?"
        handler={() => handleGenerateBir2037()}
        isClicked={isClicked}
      />
      <BirForm
        id={selectedRow.id}
        type="sales-invoice"
        mode={selectedRow.payment_mode}
      />
    </div>
  )
}
